import gql from 'graphql-tag'

export const queryContractCategoryList = () => {
	return {
		query: gql`
			{
				conf_contract_category {
					id
					category
				}
			}
		`,
		update(data) {
			return data.conf_contract_category.map(item => ({
				id: item.id,
				category: item.category
			}))
		}
	}
}
